// src/config/helpConfig.ts
import { PageHelpConfig } from '@/components/common/PageHelp';

/**
 * Dashboard help configuration
 */
export const dashboardHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.dashboard.title',
  descriptionKey: 'resources.help.dashboard.description',
  featureKeys: [
    'resources.help.dashboard.features.kpis',
    'resources.help.dashboard.features.filters',
    'resources.help.dashboard.features.insights',
    'resources.help.dashboard.features.charts',
  ],
  tipKeys: [
    'resources.help.dashboard.tips.compareData',
    'resources.help.dashboard.tips.quickFilters',
    'resources.help.dashboard.tips.recentActivity',
  ],
};

/**
 * Activity Monitor help configuration
 */
export const activityMonitorHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.activityMonitor.title',
  descriptionKey: 'resources.help.activityMonitor.description',
  featureKeys: [
    'resources.help.activityMonitor.features.realtime',
    'resources.help.activityMonitor.features.deviceStatus',
    'resources.help.activityMonitor.features.activeSessions',
  ],
  tipKeys: [
    'resources.help.activityMonitor.tips.offline',
    'resources.help.activityMonitor.tips.abandoned',
    'resources.help.activityMonitor.tips.autoRefresh',
  ],
};

/**
 * Journeys help configuration
 */
export const journeysHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.journeys.title',
  descriptionKey: 'resources.help.journeys.description',
  featureKeys: [
    'resources.help.journeys.features.search',
    'resources.help.journeys.features.filters',
    'resources.help.journeys.features.timeline',
    'resources.help.journeys.features.export',
  ],
  tipKeys: [
    'resources.help.journeys.tips.search',
    'resources.help.journeys.tips.combine',
    'resources.help.journeys.tips.timeline',
  ],
};

/**
 * Devices help configuration
 */
export const devicesHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.devices.title',
  descriptionKey: 'resources.help.devices.description',
  featureKeys: [
    'resources.help.devices.features.inventory',
    'resources.help.devices.features.configuration',
    'resources.help.devices.features.monitoring',
  ],
  tipKeys: [
    'resources.help.devices.tips.naming',
    'resources.help.devices.tips.location',
    'resources.help.devices.tips.offline',
  ],
};

/**
 * Users help configuration
 */
export const usersHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.users.title',
  descriptionKey: 'resources.help.users.description',
  featureKeys: [
    'resources.help.users.features.roles',
    'resources.help.users.features.permissions',
    'resources.help.users.features.multiHotel',
  ],
  tipKeys: [
    'resources.help.users.tips.leastPrivilege',
    'resources.help.users.tips.inactive',
    'resources.help.users.tips.superAdmin',
  ],
};

/**
 * Settings help configuration
 */
export const settingsHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.settings.title',
  descriptionKey: 'resources.help.settings.description',
  featureKeys: [
    'resources.help.settings.features.general',
    'resources.help.settings.features.notifications',
    'resources.help.settings.features.integrations',
  ],
  tipKeys: [
    'resources.help.settings.tips.timezone',
    'resources.help.settings.tips.alerts',
    'resources.help.settings.tips.save',
  ],
};

/**
 * Alerts help configuration
 */
export const alertsHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.alerts.title',
  descriptionKey: 'resources.help.alerts.description',
  featureKeys: [
    'resources.help.alerts.features.deviceOffline',
    'resources.help.alerts.features.highErrorRate',
    'resources.help.alerts.features.dispenserErrors',
  ],
  tipKeys: [
    'resources.help.alerts.tips.severityVsNature',
    'resources.help.alerts.tips.channels',
    'resources.help.alerts.tips.cooldown',
    'resources.help.alerts.tips.days',
  ],
};

/**
 * Check-ins help configuration
 */
export const checkInsHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.checkIns.title',
  descriptionKey: 'resources.help.checkIns.description',
  featureKeys: [
    'resources.help.checkIns.features.filters',
    'resources.help.checkIns.features.details',
    'resources.help.checkIns.features.export',
  ],
  tipKeys: [
    'resources.help.checkIns.tips.status',
    'resources.help.checkIns.tips.search',
    'resources.help.checkIns.tips.timeline',
  ],
};

/**
 * Groups help configuration
 */
export const groupsHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.groups.title',
  descriptionKey: 'resources.help.groups.description',
  featureKeys: [
    'resources.help.groups.features.hierarchy',
    'resources.help.groups.features.settings',
    'resources.help.groups.features.permissions',
  ],
  tipKeys: [
    'resources.help.groups.tips.naming',
    'resources.help.groups.tips.inheritance',
    'resources.help.groups.tips.consolidation',
  ],
};

/**
 * Hotels help configuration
 */
export const hotelsHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.hotels.title',
  descriptionKey: 'resources.help.hotels.description',
  featureKeys: [
    'resources.help.hotels.features.configuration',
    'resources.help.hotels.features.devices',
    'resources.help.hotels.features.users',
  ],
  tipKeys: [
    'resources.help.hotels.tips.active',
    'resources.help.hotels.tips.timezone',
    'resources.help.hotels.tips.branding',
  ],
};

/**
 * Error Monitor help configuration
 */
export const errorMonitorHelpConfig: PageHelpConfig = {
  titleKey: 'resources.help.errorMonitor.title',
  descriptionKey: 'resources.help.errorMonitor.description',
  featureKeys: [
    'resources.help.errorMonitor.features.tracking',
    'resources.help.errorMonitor.features.abandonment',
    'resources.help.errorMonitor.features.trends',
  ],
  tipKeys: [
    'resources.help.errorMonitor.tips.focus',
    'resources.help.errorMonitor.tips.context',
    'resources.help.errorMonitor.tips.prevention',
    'resources.help.errorMonitor.tips.days',
  ],
};